import { Box, Button, MenuItem, Typography } from "@mui/material";
import Background from "../../../components/Background";
import Topnav from "../../../components/Topnav";
import { useNavigate } from "react-router-dom";
import RoundedSelect from "../../../components/RoundedSelect";
import { CheckCircle } from "@mui/icons-material";
import CopyRightTextMain from "../../../components/CopyRightTextMain";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateFields } from "../../../redux/profileSlice";
import {
  International,
  Local,
  Regional,
} from "../../../components/LocationComponents";
import { useEditableProfile } from "../../../hooks/useEditableProfile";

const EditLocationSponsor = () => {
  // Router state when opened from the Profile UI, the stored profile on a
  // reload or a pasted link (ECH-387). `RequireProfileLoaded` guarantees one
  // of them exists before this component mounts, so the initialisers below
  // are safe to dereference.
  const { profile: localProfile } = useEditableProfile();
  const sponsorProfile = localProfile?.profile?.sponsorProfile ?? {};
  const [values, setValues] = useState(sponsorProfile);
  const [disable, setDisable] = useState(!sponsorProfile.organizationalScope);
  const navigate = useNavigate();
  const selected = values.organizationalScope ?? "";

  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "sponsorProfile.organizationalScope") {
      // The store clears these answers on a scope change; the next editor must
      // not rehydrate the original profile and enable saving those stale values.
      setValues((previous) => ({
        ...previous,
        organizationalScope: value,
        countriesOrCities: [],
        regions: [],
        primaryCity: "",
        province: "",
      }));
      dispatch(
        updateFields({ field: "sponsorProfile.countriesOrCities", value: [] }),
      );
      dispatch(updateFields({ field: "sponsorProfile.regions", value: [] }));
      dispatch(
        updateFields({ field: "sponsorProfile.primaryCity", value: "" }),
      );
      dispatch(updateFields({ field: "sponsorProfile.province", value: "" }));
    }
    dispatch(updateFields({ field: name, value }));
    if (name === "sponsorProfile.organizationalScope" && value === "national") {
      setDisable(false);
    }
  };

  if (!localProfile) {
    return <div>No profile data found.</div>;
  }

  return (
    <Background>
      <Topnav />
      <Box className="selection-box">
        <Typography
          className="text-primary"
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: {
              xs: "18px",
              sm: "20px",
              md: "24px",
              lg: "26px",
              xl: "32px",
            },
            lineHeight: {
              xs: "28px",
              sm: "30px",
              md: "24px",
              lg: "38px",
              xl: "42px",
            },
            marginBottom: "5px",
          }}
        >
          Your Organizational Scope
        </Typography>
        <Typography
          variant="body"
          sx={{
            fontWeight: 400,
            fontSize: {
              xs: "12px",
              sm: "13px",
              md: "14px",
              lg: "16px",
            },
            color: "#152134",
            display: "inline-block",
          }}
        >
          {values.organizationalScope === ""
            ? `Entering the scope of your organization's operations helps us`
            : "Entering your location information helps us identify where our user base resides. Your location details are private and will not be shared without your permission."}
          determine the reach of our partnership!
        </Typography>

        <Box sx={{ marginTop: "20px", marginBottom: "10px" }}>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "14px",
              color: "#152134",
              textAlign: "left",
              marginBottom: "5px",
            }}
          >
            Organizational Scope
          </Typography>
          <RoundedSelect
            value={selected}
            name="sponsorProfile.organizationalScope"
            onChange={handleChange}
            displayEmpty
            renderValue={(selected) => {
              // Show placeholder when no value is selected
              if (!selected) {
                return <span style={{ color: "#AAB6C8" }}>Select</span>;
              }
              return selected;
            }}
            inputProps={{ "aria-label": "Without label" }} // Remove default label
          >
            <MenuItem key="National" value="national">
              National{" "}
              {selected === "national" && (
                <CheckCircle
                  sx={{ marginLeft: "auto", color: "#2A4876", width: "14px" }}
                />
              )}
            </MenuItem>
            <MenuItem key="International" value="international">
              International{" "}
              {selected === "international" && (
                <CheckCircle
                  sx={{ marginLeft: "auto", color: "#2A4876", width: "14px" }}
                />
              )}
            </MenuItem>
            <MenuItem key="Regional" value="regional">
              Regional{" "}
              {selected === "regional" && (
                <CheckCircle
                  sx={{ marginLeft: "auto", color: "#2A4876", width: "14px" }}
                />
              )}
            </MenuItem>
            <MenuItem key="Local" value="local">
              Local{" "}
              {selected === "local" && (
                <CheckCircle
                  sx={{ marginLeft: "auto", color: "#2A4876", width: "14px" }}
                />
              )}
            </MenuItem>
          </RoundedSelect>
        </Box>
        {selected === "local" && (
          <Local
            values={values}
            handleChange={handleChange}
            edit="true"
            handleDisable={setDisable}
          />
        )}
        {selected === "international" && (
          <International
            values={values}
            handleChange={handleChange}
            edit="true"
            handleDisable={setDisable}
          />
        )}
        {selected === "regional" && (
          <Regional
            selected={values.regions}
            edit="true"
            handleDisable={setDisable}
          />
        )}
        <Button
          onClick={() => navigate("/profile/edit-profile")}
          variant="contained"
          fullWidth
          className="Send-button next-btn-employment"
          disabled={disable}
          sx={{
            backgroundColor: !disable ? "#2A4876" : "#AAB6C8", // Change color based on input values
            cursor: !disable ? "pointer" : "not-allowed", // Disable hover effect when fields are not filled
            color: "#fff",
          }}
        >
          Save
        </Button>
      </Box>
      <CopyRightTextMain />
    </Background>
  );
};

export default EditLocationSponsor;
